module.exports = __webpack_public_path__ + "static/media/Insta.6e393ad2.png";